export default {
  API: {
    BASE_URL: ''
  },
  B2C: {
    CLIENT_ID: '',
    AUTHORITY: '',
    B2C_SCOPES: ''
  },
  TIMESPANS: {
    INDEMNITY_PROCESS: {
      FROM: '',
      UNTIL: ''
    }
  }
};
